export const updateHeaderPositionForBaner = () => {
  const widgetElement = document.querySelector('.vlw__header') as HTMLElement;
  const communicationBanners = document.querySelectorAll(
    '.communication-banner',
  ) as NodeListOf<HTMLElement>;

  let totalHeight = 0;

  communicationBanners.forEach((banner) => {
    totalHeight += banner.offsetHeight;
  });

  const index = communicationBanners.length > 1 ? 1 : 0;

  if (communicationBanners.length > 0) {
    const updateWidgetPosition = () => {
      const bannerRect = communicationBanners[index].getBoundingClientRect();

      if (communicationBanners[index].offsetHeight + bannerRect.top >= 0) {
        widgetElement.style.top = `${communicationBanners[index].offsetHeight +
          bannerRect.top}px`;
      } else {
        widgetElement.style.top = '0px';
      }
    };

    window.addEventListener('scroll', updateWidgetPosition);
    updateWidgetPosition();

    return () => window.removeEventListener('scroll', updateWidgetPosition);
  }
};
